<div class="footer">
  <div class="row">
    <div class="col-sm-10">
      <ul class="list-unstyled">
        <li>
          {{ company.commercial_name || company.company_name }}
        </li>
        <li>
          {{ 'TELEPHONE' | translate }}: {{ company.phone_code }}
          {{ company.phone_number }}
        </li>
        <li>{{ 'EMAIL' | translate }}: {{ company.email }}</li>
        <li>
          {{ company.address }}.
          {{ company.district ? company.district.name : company.address_district }},
          {{ company.city ? company.city.name : company.address_city }},
          {{ company.country.name }}
        </li>
        <li>
          {{ company.website }}
        </li>
      </ul>
    </div>
    <div class="col-sm-2">
      <div class="footer-powered">
        {{ 'POWERED_BY' | translate }}
        <div class="logo" title="TIM"></div>
      </div>
    </div>
  </div>
</div>

<!-- {{ 'ADDRESS' | translate }}:  -->
<!-- {{ company.company_name }}  -->
<!-- <p> -->
<!-- WE NEED THE SOURCE HERE -->
<!-- <div ng-if="automatic"> -->
<!-- {{ 'PROCESSED_BY' | translate }}: {{ company.website }} -->
<!-- </div> -->
<!-- <div ng-if="!automatic">
        <div ng-if="user">
            {{ 'PROCESSED_BY' | translate }}: {{ user.first_name }} {{ user.last_name }} - {{ user.email }}
        </div>
        <div ng-if="!user">
            {{ 'PROCESSED_BY' | translate }}: {{ company.website.url }}
        </div>
    </div> -->
<!-- </p> -->
